function debounce(func, delay) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), delay);
  };
}

const observer = new MutationObserver((mutationsList, observer) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList') {
      const atcBanner = document.querySelector('.atc-banner--container');
      if (atcBanner) {
        const removeAttrAndTrigger = debounce(() => {
          $("button.button-primary.atc-button--checkout.mdc-ripple-surface.mdc-ripple-upgraded").removeAttr("bss-b2b-cart-trigger-added");
          BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
        }, 300);
        removeAttrAndTrigger();
      }
    }
  });
});

const config = { childList: true, subtree: true };

const targetNode = document.querySelector('body');

if (targetNode) {
  observer.observe(targetNode, config);
}
